(function () {
  'use strict';
  function init() {
    var wrap = document.querySelector('.au-chat');
    if (!wrap || wrap.querySelector('.au-chat__dock')) return;
    var toggle = wrap.querySelector('.au-chat__toggle');
    var panel = wrap.querySelector('.au-chat__panel');
    var mobile = matchMedia('(max-width: 749px), (max-height: 500px) and (pointer: coarse)');
    var dock = document.createElement('div');
    dock.className = 'au-chat__dock';
    var rail = document.createElement('div');
    rail.className = 'au-chat__rail';
    rail.id = 'au-chat-controls';
    function button(className, label, path) {
      var el = document.createElement('button');
      el.type = 'button';
      el.className = className;
      el.setAttribute('aria-label', label);
      el.innerHTML = '<svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="' + path + '"/></svg>';
      return el;
    }
    var reveal = button('au-chat__reveal', 'Show contact button', 'M15 5l-7 7 7 7');
    var hide = button('au-chat__hide', 'Hide contact button', 'M9 5l7 7-7 7');
    reveal.setAttribute('aria-controls', rail.id);
    wrap.insertBefore(dock, toggle);
    dock.appendChild(rail);
    rail.append(reveal, toggle, hide);
    var revealed = false;
    try { revealed = sessionStorage.getItem('landot-chat-revealed') === 'true'; } catch (_) {}
    function update(value, focus) {
      revealed = value;
      wrap.classList.toggle('is-revealed', value);
      reveal.setAttribute('aria-expanded', String(value));
      toggle.inert = mobile.matches && !value;
      hide.inert = mobile.matches && !value;
      if (focus) (value ? toggle : reveal).focus();
      try { sessionStorage.setItem('landot-chat-revealed', String(value)); } catch (_) {}
    }
    reveal.addEventListener('click', function () { update(true, true); });
    hide.addEventListener('click', function () { update(false, true); });
    rail.addEventListener('keydown', function (e) {
      if (mobile.matches && e.key === 'Escape') update(false, true);
    });
    var start = null;
    var suppressClickUntil = 0;
    rail.addEventListener('pointerdown', function (e) {
      if (!mobile.matches || !e.isPrimary || e.button !== 0) return;
      suppressClickUntil = 0;
      start = { x: e.clientX, y: e.clientY, id: e.pointerId };
      (e.target.closest('button') || rail).setPointerCapture(e.pointerId);
    });
    rail.addEventListener('pointerup', function (e) {
      if (!start || start.id !== e.pointerId) return;
      var dx = e.clientX - start.x;
      var dy = e.clientY - start.y;
      start = null;
      if (Math.abs(dx) >= 24 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        suppressClickUntil = Date.now() + 400;
        update(dx < 0, false);
      }
    });
    rail.addEventListener('pointercancel', function () { start = null; });
    rail.addEventListener('click', function (e) {
      if (Date.now() < suppressClickUntil) {
        suppressClickUntil = 0;
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);
    new MutationObserver(function () {
      if (mobile.matches && panel.classList.contains('is-open')) update(true, false);
    }).observe(panel, { attributes: true, attributeFilter: ['class'] });
    mobile.addEventListener('change', function () { update(revealed, false); });
    update(revealed, false);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
